import { formatDate } from '../utils/formatDate';

interface DateCellProps {
  value: string | undefined | null;
}

export default function DateCell({ value }: DateCellProps) {
  return <span className="whitespace-nowrap">{formatDate(value)}</span>;
}
